import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { internalCreators } from '../creators';
import { ArgumentVisitor } from './argument';
import { getPositionFromContext, JastBuildingVisitor } from './common';
import { StringVisitor } from './string';
export var FieldVisitor = /*#__PURE__*/function (_JastBuildingVisitor) {
  _inherits(FieldVisitor, _JastBuildingVisitor);
  var _super = _createSuper(FieldVisitor);
  function FieldVisitor() {
    var _this;
    _classCallCheck(this, FieldVisitor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "stringVisitor", new StringVisitor(_this.tokens));
    _defineProperty(_assertThisInitialized(_this), "fieldPropertyVisitor", new FieldPropertyVisitor(_this.tokens));
    _defineProperty(_assertThisInitialized(_this), "visitJqlNumberField", function (ctx) {
      var text = _this.tokens.getText(ctx);
      return internalCreators.field(text, text, undefined, getPositionFromContext(ctx));
    });
    _defineProperty(_assertThisInitialized(_this), "visitJqlNonNumberField", function (ctx) {
      var stringContext = ctx.jqlString();
      var properties = ctx.jqlFieldProperty().map(function (context) {
        return context.accept(_this.fieldPropertyVisitor);
      });
      if (stringContext !== undefined) {
        var stringValue = stringContext.accept(_this.stringVisitor);
        return internalCreators.field(stringValue.value, stringValue.text, properties, getPositionFromContext(ctx));
      }
      var text = _this.tokens.getText(ctx);
      return internalCreators.field(text, text, properties, getPositionFromContext(ctx));
    });
    return _this;
  }
  return _createClass(FieldVisitor);
}(JastBuildingVisitor);
var FieldPropertyVisitor = /*#__PURE__*/function (_JastBuildingVisitor2) {
  _inherits(FieldPropertyVisitor, _JastBuildingVisitor2);
  var _super2 = _createSuper(FieldPropertyVisitor);
  function FieldPropertyVisitor() {
    var _this2;
    _classCallCheck(this, FieldPropertyVisitor);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "argumentVisitor", new ArgumentVisitor(_this2.tokens));
    _defineProperty(_assertThisInitialized(_this2), "propertyArgumentVisitor", new PropertyArgumentVisitor(_this2.tokens));
    _defineProperty(_assertThisInitialized(_this2), "visitJqlFieldProperty", function (ctx) {
      var argumentContext = ctx.jqlArgument();
      var propertyArgumentContext = ctx.jqlPropertyArgument();
      var path = propertyArgumentContext.map(function (context) {
        return context.accept(_this2.propertyArgumentVisitor);
      });
      return internalCreators.property(argumentContext && argumentContext.accept(_this2.argumentVisitor), path, getPositionFromContext(ctx));
    });
    return _this2;
  }
  return _createClass(FieldPropertyVisitor);
}(JastBuildingVisitor);
var PropertyArgumentVisitor = /*#__PURE__*/function (_JastBuildingVisitor3) {
  _inherits(PropertyArgumentVisitor, _JastBuildingVisitor3);
  var _super3 = _createSuper(PropertyArgumentVisitor);
  function PropertyArgumentVisitor() {
    var _this3;
    _classCallCheck(this, PropertyArgumentVisitor);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this3 = _super3.call.apply(_super3, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "argumentVisitor", new ArgumentVisitor(_this3.tokens));
    _defineProperty(_assertThisInitialized(_this3), "visitJqlPropertyArgument", function (ctx) {
      return ctx.jqlArgument().accept(_this3.argumentVisitor);
    });
    return _this3;
  }
  return _createClass(PropertyArgumentVisitor);
}(JastBuildingVisitor);